// extracted by mini-css-extract-plugin
export var closeBtn = "PlayerModal-module--closeBtn--a4af7";
export var container = "PlayerModal-module--container--3c22a";